import { Injectable } from '@angular/core';
import {RequestOptions, URLSearchParams, Http, Headers} from "@angular/http";
import {Observable} from  "rxjs/Observable";
import {LoadingService} from "../providers/loading-service";
import {Config} from '../config/config';
import {AuthStore} from '../stores/auth-store';

import 'rxjs';

@Injectable()
export class HttpService {

  constructor(protected http: Http, protected loadingService:LoadingService, protected authStore:AuthStore) {
  }

  /**
   * 通信時パラメータ生成
   */
  buildParam(userParam: URLSearchParams): RequestOptions {

    var headers = new Headers();
    headers.append("Accept", 'application/json');
    headers.append('Content-Type', 'application/json' );
    headers.append('token', this.authStore.token );
    headers.append("scheme", Config.getSet()["SCHEME"]); //mongodbスキーマ

    //API URL
    var apiUrl = Config.getSet()["API_URL"] + userParam.get("api");
    userParam.delete("api");

    //Urlパラメータオブジェクト作成
    let urlSearchParam = new URLSearchParams();
    urlSearchParam.setAll(userParam);

    //通信設定オブジェクト作成
    let options = {
      headers: headers,
      url: apiUrl,
      params: urlSearchParam
    };
    return new RequestOptions(options);
  };

  /**
   * GET
   */
  get(options: RequestOptions): Observable<any>{

    if (options["needLoading"]){
      this.loadingService.present("");
    }

    return this.http.get(options.url, options)
      .map(res=>res.json())
      .catch(this.handleError)
      .finally(()=>{ 
        if (options["needLoading"]) {
          this.loadingService.dissmiss();
        }
      });
  }

  /**
   * POST
   */
  post(options: RequestOptions, data:object): Observable<any>{

    this.loadingService.present("");

    if(this.authStore.getLogin()){
      data["modified_user"] = this.authStore.getLoginData("id");
    }

    return this.http.post(options.url, JSON.stringify(data), options)
      .map(res=>res.json())
      .catch(this.handleError)
      .finally(()=>{ 
        this.loadingService.dissmiss();
      });
  }

  // エラー処理
  private handleError (error: any) {
    alert("エラーが発生しました。");
    console.error(error); // log to console instead
    let errMsg = error.message || 'Server error';
    return Observable.throw(errMsg);
    // return Observable.from("hogehoge");
  };
}


// WEBPACK FOOTER //
// ./src/providers/http-service.ts